import React from 'react'
import { Link } from 'react-router-dom'

const SideBar = () => {
  return (
    <div>
      <div id="side-hide">
        <div className="top-area" style={{backgroundColor : "white"}}>
            <Link to="/" className="logo-area">
                {/* <img src={require("../assets/images/logo/logo-03.png")} alt="logo"/> */}
                <img src={"/assets/images/logo/starpath-logo.svg"} alt="logo"/>
            </Link>
            <div className="close-icon-area">
                <div id="close-slide__main">
                    <i className="fa-solid fa-x"></i>
                </div>
            </div>
        </div>
        <hr></hr>
        <div className="body">

            <div className="image-area-feature">
                <img src={require("../assets/images/sidebar/01.jpg")} alt="sidebar"/>
            </div>
            <h5 className="title mt--30">Transforming your ideas into digital reality</h5>
            <p className="disc">
                We help you turn innovative ideas into impactful digital solutions. From strategy to execution, our expert team ensures your vision is brought to life with precision, creativity, and technology-driven excellence.
            </p>
            <div className="short-contact-area-side-collups">
                {/* single contact information */}
                <div className="single-contact-information-side">
                    <i className="fa-solid fa-phone"></i>
                    <div className="information">
                        <span>Call Now</span>
                        <Link to="#" className="number">+919057000445 &nbsp;|&nbsp;+919057000446`</Link>
                    </div>
                </div>
                {/* single contact information end */}
                {/* single contact information */}
                <div className="single-contact-information-side">
                    <i className="fa-light fa-envelope"></i>
                    <div className="information">
                        <span>Mail Us</span>
                        <Link to="#" className="number">info@starparth.com</Link>
                    </div>
                </div>
                {/* single contact information end */}
                {/* single contact information */}
                <div className="single-contact-information-side">
                    <i style={{width: "100px"}} className="fa-sharp fa-light fa-location-dot"></i>
                    <div className="information">
                        <span>Our Address</span>
                        <Link to="#" className="number">G2 Aanchal Apartment 1/55 Roshan Marg </Link>
                        <Link to="#" className="number">Chitrakoot Jaipur Rajasthan 302021 </Link>
                    </div>
                </div>
                {/* single contact information end */}
            </div>
            {/* social area start */}
            <ul className="social-icons solid-social-icons rounded-social-icons">
                <li><Link to="https://www.facebook.com/starparthexamination/"><i className="fa-brands fa-facebook-f"></i></Link></li>
                <li><Link to="#"><i className="fa-brands fa-linkedin-in"></i></Link></li>
                <li><Link to="https://x.com/Starparthtech"><i className="fa-brands fa-twitter"></i></Link></li>
                <li><Link to="https://www.instagram.com/starparthtechnologies/"><i className="fa-brands fa-instagram"></i></Link></li>
            </ul>
            {/* social area end */}
        </div>
        {/* mobile menu area start */}
        <div className="mobile-menu-main">
            <nav className="nav-main mainmenu-nav mt--30">
                <ul className="mainmenu metismenu" id="mobile-menu-active">
                    <li>
                        <Link to="/" className="main">Home</Link>
                    </li>     
                    <li className="has-droupdown">
                        <Link to="#" className="main">Services</Link>
                        <ul className="submenu mm-collapse">
                            <li><Link className="mobile-menu-link" to="/agency">Infra Service Provider</Link></li>
                            <li><Link className="mobile-menu-link" to="/itconsulting">IT Consulting</Link></li>
                            <li><Link className="mobile-menu-link" to="/marketing">Digital Marketing</Link></li>
                            <li><Link className="mobile-menu-link" to="/financial">Financial Consulting</Link></li>
                        </ul>
                    </li>
                    <li>
                        <Link to="/training-internship" className="main">Training &amp; Internship</Link>
                    </li>
                    <li>
                        <Link to="/contact" className="main">Contact Us</Link>
                    </li>
                </ul>
            </nav>

        </div>
        {/* mobile menu area end */}
    </div>

    </div>
  )
}

export default SideBar